import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Target Type
export const typeList = (params = '') => Http.get(`/marketing-campaign-types${serialize(params)}`)
export const typeCreate = (params = '') => Http.post('/marketing-campaign-types', params)
export const typeByID = (params = '') => Http.get(`/marketing-campaign-types/${params}`)
export const typeUpdate = (params = '') => Http.put(`/marketing-campaign-types/${params.id}`, params)
export const typeDestroy = (params = '') => Http.delete(`/marketing-campaign-types/${params.id}`)
